/** 排序元素类型声明 */
type TSortItem = {
  sortTag: string;
};

/** 排序工具 */
class SortUtil {
  /**
   * 根据字符串的字母(A-Z)进行排序，特殊字符排在最后
   * @param list 需要排序的数据列表
   * @returns 排好序的数据列表
   */
  public static sortStringListByLetter<T extends TSortItem>(list: Array<T>): Array<T> {
    if (!list.length) {
      return [];
    }

    const letterRegExp = /^[a-zA-Z].*$/;
    const letterList: Array<T> = [];
    const noLetterList: Array<T> = [];
    for (const item of list) {
      const { sortTag } = item;
      if (letterRegExp.test(sortTag)) {
        letterList.push(item);
      } else {
        noLetterList.push(item);
      }
    }
    letterList.sort((a, b) => a.sortTag.localeCompare(b.sortTag));
    noLetterList.sort((a, b) => a.sortTag.localeCompare(b.sortTag));
    return [...letterList, ...noLetterList];
  }
}

export { SortUtil };
